import React from 'react';
import styled from 'styled-components';

const getSize = (prop) => {
  const { size = '18px' } = prop;
  const variations = {
    'xsmall': '12px',
    'small': '14px',
    'medium': '18px',
    'large': '22px',
    'xlarge': '26px',
    'xxlarge': '34px'
  };

  return variations[size] ? variations[size] : size;
};

const getHeight = (prop) => {
  const { height = 'normal' } = prop;
  const variations = {
    'xsmall': '18px',
    'small': '20px',
    'medium': '24px',
    'large': '28px',
    'xlarge': '32px'
  };

  return variations[height] ? variations[height] : height;
};

const getMargin = (prop) => {
  const { margin = '0px' } = prop;
  const variations = {
    'none': '0px',
    'hair': '1px',
    'xxsmall': '3px',
    'xsmall': '6px',
    'small': '12px',
    'medium': '24px',
    'large': '48px',
    'xlarge': '96px'
  };

  return variations[margin] ? variations[margin] : margin;
};

const getColor = (prop) => {
  const { color = 'black' } = prop;
  const variations = {
    brand: '#2e4787',
    blueLink: '#05629b',
    'dark-2': '#333333'
  };

  return variations[color] ? variations[color] : color;
};

const StyledStrong = styled.strong`
  font-size: ${prop => getSize(prop)};
  line-height: ${prop => getHeight(prop)};
  color: ${prop => getColor(prop)};
  margin: ${prop => getMargin(prop)};
  align-self: ${prop => (prop.alignSelf || 'auto')};
`;

export default function Strong(prop) {
  const { text, ...rest } = prop;

  return (
    <>
      <StyledStrong {...rest}>
        {text}
      </StyledStrong>
    </>
  );
};
